import { instanceApi } from '@/services/ProviderService'

export default {
    getInvoice(invoiceDocNo){
        return instanceApi().get(`/api/invoice/${invoiceDocNo}`).then(res => res.data);
    }
}
